import tabHistory from './history.tab';
import collapseHistory from './history.collapse';

function init() {
    tabHistory.init();
    collapseHistory.init();
}

export default {
    init
};
